import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';
import { Sede } from '../_models/sede';
import { AnaGenerale } from '../_models/ana-generale';

@Injectable({
	providedIn: 'root'
})
export class AccountService {

	constructor(
		private http: HttpClient,
		private config: AppConfig) { }

	// get(id: number) {
	// 	return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/account` + id);
	// }

	upsertSede(s: Sede) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/account/locations`, s);
	}

	deleteSede(id: number) {
		return this.http.delete<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/account/locations/` + id);
	}

	getSedi() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/account/locations`);
	}

	update(ana: AnaGenerale) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/account`, ana);
	}

}
